import React from 'react';
import {Divider} from '@material-ui/core';
import {FlexBoxHeader, HeaderContainer, HeaderDescription, HeaderTitle} from './styles';
import {IApplication} from '../../../Interfaces/interfaces';
import ActivationButton
    from "./AppActivationButton/AppActivationButton";

interface IAppInfoHeaderProps {
    app: IApplication;
    isAdmin: boolean;
    onActivationButtonClick: () => void;
}

const AppInfoHeader = (props: IAppInfoHeaderProps) => (
    <>
        <HeaderContainer>
            <FlexBoxHeader>
                <HeaderTitle>{props.app.displayName}</HeaderTitle>
            </FlexBoxHeader>

            {props.isAdmin && (
                <ActivationButton
                    isActive={props.app.isEnabled}
                    onActivationButtonClick={() => props.onActivationButtonClick()}
                />
            )}
        </HeaderContainer>

        {(props.app.description || props.app.version) && (
            <HeaderContainer>
                <HeaderDescription>
                    {props.app.description}
                </HeaderDescription>

                {props.app.version}
            </HeaderContainer>
        )}

        <Divider/>
    </>
);

export default AppInfoHeader;
